import { RouteLocationNormalized } from 'vue-router';
import { TUserRole } from '@/modules/acl/aclService';
import {
  CurrentUserApiResource,
  CurrentUserApiResourceType,
  GuestApiResource,
  ManagerApiResource,
  OwnerApiResource,
  VendorApiResource,
} from '@/api';

export const VIEW_AS_QUERY_KEY = 'viewAs';

export const SWITCHABLE_TARGET_ROLES = ['manager'] as const;
type SwitchableRole = (typeof SWITCHABLE_TARGET_ROLES)[number];

const isSwitchableRole = (value: string): value is SwitchableRole =>
  (SWITCHABLE_TARGET_ROLES as readonly string[]).includes(value);

export const getViewAsRole = (route: RouteLocationNormalized): TUserRole | null => {
  const raw = route.query[VIEW_AS_QUERY_KEY];

  if (typeof raw !== 'string') {
    return null;
  }

  if (isSwitchableRole(raw)) {
    return raw as TUserRole;
  }

  return null;
};

export const isViewAsAllowed = (
  user: CurrentUserApiResource | ManagerApiResource | GuestApiResource | OwnerApiResource | VendorApiResource | null,
  targetRole: TUserRole | null,
): boolean => {
  if (!user || !targetRole) {
    return false;
  }

  return user.type === CurrentUserApiResourceType.admin && targetRole === 'manager';
};

export const getEffectiveRole = (
  user: CurrentUserApiResource | ManagerApiResource | GuestApiResource | OwnerApiResource | VendorApiResource | null,
  route: RouteLocationNormalized,
): TUserRole | null => {
  const viewAsRole = getViewAsRole(route);

  if (isViewAsAllowed(user, viewAsRole)) {
    return viewAsRole;
  }

  return null;
};
